import React from 'react'

const Dashboard = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Dashboard</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active">Dashboard</li>
          </ol>
        </nav>
      </div>{/* End Page Title */}
      <section className="section dashboard">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Auditor Dashboard</h5>
                <p>Welcome to the Auditor Dashboard. Use the sidebar to navigate to different audit reports and verification screens.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Dashboard

